import * as React from 'react';
import BtnEditAct from "../../Buttons/BtnEditAct/BtnEditAct";
import NHeading1 from "../../TextComponents/NHeading1/NHeading1";

export const ConfirmActionModalDefProps = {
  initActionBtn: (<BtnEditAct>Init action</BtnEditAct>),
  children: (<NHeading1 addClasses={"mt_2du mb_2du ta_c"}>Do you confirm action?</NHeading1>),
  onModalActionBtnClick: ()=>{}
};